import { render, staticRenderFns } from "./TenantInviteUserDialog.vue?vue&type=template&id=3bf495a5&scoped=true&"
import script from "./TenantInviteUserDialog.vue?vue&type=script&lang=js&"
export * from "./TenantInviteUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf495a5",
  null
  
)

export default component.exports